import { render } from "./AboutSection.vue?vue&type=template&id=ade0731a&ts=true"
import script from "./AboutSection.vue?vue&type=script&lang=ts"
export * from "./AboutSection.vue?vue&type=script&lang=ts"

import "./AboutSection.vue?vue&type=style&index=0&id=ade0731a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__